import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { useFaqToggleHandler, useLinkClickHandler } from './FrequentlyAskedQuestionsUtils';
import { getProductAndServicesCatalogUrlPublic } from './FrequentlyAskedQuestionsPublicPageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const productAndServicesCatalogHref = getProductAndServicesCatalogUrlPublic();
export const HubspotCreditsFaqs = ({
  onLinkClick,
  onFaqInteraction
} = {}) => {
  const handleFaqToggle = useFaqToggleHandler(onFaqInteraction);
  const handleLinkClick = useLinkClickHandler(onLinkClick);
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.hubspot-credits.whatAreHubSpotCredits.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.hubspot-credits.whatAreHubSpotCredits.answer"
      }),
      onExpandedChange: () => handleFaqToggle('hubspot-credits.whatAreHubSpotCredits', 'pricing-page-components.frequentlyAskedQuestions.hubspot-credits.whatAreHubSpotCredits.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.hubspot-credits.howMuchDoesOneHubSpotCreditEqual.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.hubspot-credits.howMuchDoesOneHubSpotCreditEqual.answer",
        options: {
          productAndServicesCatalogLink: /*#__PURE__*/_jsx(Link, {
            href: productAndServicesCatalogHref,
            external: true,
            onClick: () => handleLinkClick('hubspot-credits.howMuchDoesOneHubSpotCreditEqual.productAndServicesCatalog', productAndServicesCatalogHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.hubspot-credits.howMuchDoesOneHubSpotCreditEqual.productAndServicesCatalog"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('hubspot-credits.howMuchDoesOneHubSpotCreditEqual', 'pricing-page-components.frequentlyAskedQuestions.hubspot-credits.howMuchDoesOneHubSpotCreditEqual.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.hubspot-credits.howDoHubSpotCreditsWork.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.hubspot-credits.howDoHubSpotCreditsWork.answer"
      }),
      onExpandedChange: () => handleFaqToggle('hubspot-credits.howDoHubSpotCreditsWork', 'pricing-page-components.frequentlyAskedQuestions.hubspot-credits.howDoHubSpotCreditsWork.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.hubspot-credits.doCreditsReset.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.hubspot-credits.doCreditsReset.answer"
      }),
      onExpandedChange: () => handleFaqToggle('hubspot-credits.doCreditsReset', 'pricing-page-components.frequentlyAskedQuestions.hubspot-credits.doCreditsReset.question')
    })]
  });
};